// extracted by mini-css-extract-plugin
export default {"text":"EventRegistration_text__gTUwk","info":"EventRegistration_info__uB8Js"};